// extracted by mini-css-extract-plugin
export default {"container":"TestFinished_container__bBXvH","header":"TestFinished_header__wUW7d","content":"TestFinished_content__umqz7","buttonsContainer":"TestFinished_buttonsContainer__MLsX5"};